// @generated by protoc-gen-es v1.6.0 with parameter "target=js"
// @generated from file dymensionxyz/dymension/gamm/pool-models/balancer/tx.proto (package dymensionxyz.dymension.gamm.poolmodels.balancer.v1beta1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { PoolAsset, PoolParams } from "./balancerPool_pb";

/**
 * ===================== MsgCreatePool
 *
 * @generated from message dymensionxyz.dymension.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool
 */
export const MsgCreateBalancerPool = proto3.makeMessageType(
  "dymensionxyz.dymension.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool",
  () => [
    { no: 1, name: "sender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pool_params", kind: "message", T: PoolParams },
    { no: 3, name: "pool_assets", kind: "message", T: PoolAsset, repeated: true },
    { no: 4, name: "future_pool_governor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Returns the poolID
 *
 * @generated from message dymensionxyz.dymension.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPoolResponse
 */
export const MsgCreateBalancerPoolResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPoolResponse",
  () => [
    { no: 1, name: "pool_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

